<div id="register" fxLayout="column">

    <div id="register-form-wrapper" fxLayout="column" fxLayoutAlign="center center">

        <div id="register-form" [@animate]="{value:'*',params:{duration:'300ms',y:'100px'}}">

            <div class="logo">
                <img src="assets/images/logos/logo.svg">
            </div>

            <div class="title">CREATE AN ACCOUNT</div>

            <form name="registerForm" [formGroup]="registerForm" novalidate (submit)="submitForm()">

                <mat-form-field>
                    <mat-label>Email</mat-label>
                    <input matInput name="mynet-register-email" formControlName="email" required
                        pattern="^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$" type="email">
                    <mat-icon matSuffix class="secondary-text">mail</mat-icon>
                    <mat-error *ngIf="registerForm.get('email').hasError('required')">
                        Email is required
                    </mat-error>
                    <mat-error
                        *ngIf="registerForm.get('email').hasError('email') || registerForm.get('email').hasError('pattern')">
                        Please enter a valid email address
                    </mat-error>
                </mat-form-field>

                <mat-form-field>
                    <mat-label>Password</mat-label>
                    <input matInput type="password" name="mynet-register-password" formControlName="password"
                        autocomplete="false" required>
                    <mat-icon matSuffix class="secondary-text">vpn_key</mat-icon>
                    <mat-error *ngIf="registerForm.get('password').hasError('required')">
                        Password is required
                    </mat-error>
                </mat-form-field>
                <div class="w-100-p">
                    <mat-label style="display: flex; flex: 1"
                        *ngIf="registerForm.controls['password'].hasError('minlength')"
                        class="text-danger w-100-p mb-8">
                        <mat-icon class="mr-4">cancel</mat-icon>
                        Must be at least 8 characters!
                    </mat-label>
                    <mat-label style="display: flex; flex: 1"
                        *ngIf="registerForm.controls['password'].hasError('hasNumber')"
                        class="text-danger w-100-p mb-8">
                        <mat-icon class="mr-4">cancel</mat-icon>
                        Must contain at least 1 number!
                    </mat-label>
                    <mat-label style="display: flex; flex: 1"
                        *ngIf="registerForm.controls['password'].hasError('hasCapitalCase')"
                        class="text-danger w-100-p mb-8">
                        <mat-icon class="mr-4">cancel</mat-icon>
                        Must contain at least 1 in Capital Case!
                    </mat-label>
                    <mat-label style="display: flex; flex: 1"
                        *ngIf="registerForm.controls['password'].hasError('hasSmallCase')"
                        class="text-danger w-100-p mb-8">
                        <mat-icon class="mr-4">cancel</mat-icon>
                        Must contain at least 1 Letter in Lower Case!
                    </mat-label>
                    <mat-label style="display: flex; flex: 1"
                        *ngIf="registerForm.controls['password'].hasError('hasSpecialCharacters')"
                        class="text-danger w-100-p mb-8">
                        <mat-icon class="mr-4">cancel</mat-icon>
                        Must contain at least 1 Special Character!
                    </mat-label>
                </div>

                <mat-form-field>
                    <mat-label>Password (Confirm)</mat-label>
                    <input matInput type="password" name="mynet-register-confirm-pasword"
                        formControlName="confirmPassword" required>
                    <mat-icon matSuffix class="secondary-text">vpn_key</mat-icon>
                    <mat-error *ngIf="registerForm.get('confirmPassword').hasError('required')">
                        Password confirmation is required
                    </mat-error>
                    <mat-error *ngIf="!registerForm.get('confirmPassword').hasError('required') &&
                                       registerForm.get('confirmPassword').hasError('passwordsNotMatching')">
                        Passwords must match
                    </mat-error>
                </mat-form-field>

                <mat-error class="error-message" *ngIf="errorMessage">
                    {{errorMessage}}
                </mat-error>

                <mat-progress-bar *ngIf="loading" mode="indeterminate"></mat-progress-bar>

                <button mat-raised-button color="accent" class="submit-button" aria-label="CREATE AN ACCOUNT"
                    type="submit" [disabled]="registerForm.invalid">
                    CREATE AN ACCOUNT
                </button>

            </form>

            <div class="register" fxLayout="column" fxLayoutAlign="center center">
                <span class="text">Already have an account?</span>
                <a class="link" [routerLink]="'/auth/login'">Login</a>
            </div>

        </div>

    </div>

</div>